import { render, staticRenderFns } from "./ProdutoDisponibilidade.vue?vue&type=template&id=01219876&scoped=true"
import script from "./ProdutoDisponibilidade.vue?vue&type=script&lang=js"
export * from "./ProdutoDisponibilidade.vue?vue&type=script&lang=js"
import style0 from "./ProdutoDisponibilidade.vue?vue&type=style&index=0&id=01219876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01219876",
  null
  
)

export default component.exports